
import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function CallToActionSection() {
  return (
    <section className="py-20 bg-gradient-to-r from-red-600 to-red-800 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 relative">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          <div className="space-y-4">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight">
              Looking to buy or refinance in <span className="text-red-100">Ontario</span>?
            </h2>
            <p className="text-xl text-red-100 leading-relaxed">
              Book a Call with Tony Monteiro today and get expert mortgage advice tailored to your neighbourhood.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a 
              href="https://calendly.com/tmonteiro-mortgagealliance/30min"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button 
                variant="outline" 
                size="lg" 
                className="bg-white text-red-600 hover:bg-red-50 border-white px-8 py-4 text-lg whitespace-nowrap"
              >
                <i className="ri-calendar-line mr-2"></i>
                Book a Call
              </Button>
            </a>
            <div className="flex items-center gap-4 text-white">
              <span className="text-red-100">or call directly:</span>
              <a 
                href="tel:5196583026" 
                className="flex items-center gap-2 text-white hover:text-red-100 font-semibold text-lg transition-colors duration-200"
              >
                <i className="ri-phone-line"></i>
                (519) 658-3026
              </a>
            </div>
          </div>

          {/* Trust indicators */}
          <div className="pt-8 border-t border-red-500/30">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-2xl mx-auto">
              <div className="text-center">
                <div className="text-2xl font-bold text-white mb-1">25+ Years</div>
                <div className="text-red-100 text-sm">Experience</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-white mb-1">Level 2</div>
                <div className="text-red-100 text-sm">Certified Professional</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-white mb-1">3 Counties</div>
                <div className="text-red-100 text-sm">Served</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
